import React, { useState } from 'react';

const WelcomeModal = ({ user, onClose }) => {
  const [selectedInterest, setSelectedInterest] = useState(null);

  const topics = [
    {
      id: 'financial',
      title: 'Financial Literacy',
      icon: '💰',
      description: 'Banking, budgeting, and money management',
      navigate: 'courses'
    },
    {
      id: 'mental_health',
      title: 'Mental Health & Wellness',
      icon: '🧠',
      description: 'Self-care and emotional well-being',
      navigate: 'courses'
    },
    {
      id: 'job_skills',
      title: 'Job Skills & Career',
      icon: '💼',
      description: 'Interview prep and workplace skills',
      navigate: 'digitaltwin'
    },
    {
      id: 'cultural',
      title: 'Cultural Immersion',
      icon: '🌍',
      description: 'Understanding American society',
      navigate: 'simulation'
    },
    {
      id: 'english',
      title: 'English Language',
      icon: '📚',
      description: 'Improve communication skills',
      navigate: 'courses'
    },
    {
      id: 'technology',
      title: 'Technology & Digital',
      icon: '🖥️',
      description: 'Navigate the digital world',
      navigate: 'courses'
    }
  ];

  const handleTopicClick = (topic) => {
    setSelectedInterest(topic);
  };

  const handleGetStarted = () => {
    if (selectedInterest) {
      // Navigate to the appropriate section
      window.location.hash = `#${selectedInterest.navigate}`;
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-8 rounded-t-2xl text-center">
          <h1 className="text-4xl font-bold mb-2">Welcome to NET2! 🎉</h1>
          <p className="text-xl opacity-90">Hi {user?.first_name}! We're thrilled to have you here!</p>
          <p className="text-lg mt-2 opacity-75">Nurturing Potential through Measurable Impact</p>
        </div>

        {/* Content */}
        <div className="p-8">
          <div className="mb-8 text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              🌟 What would you like to learn about today?
            </h2>
            <p className="text-gray-600">
              Choose a topic below, and we'll help you find the perfect resources!
            </p>
          </div>

          {/* Topics Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
            {topics.map((topic) => (
              <button
                key={topic.id}
                onClick={() => handleTopicClick(topic)}
                className={`p-6 rounded-xl border-2 transition-all text-left hover:shadow-lg ${
                  selectedInterest?.id === topic.id
                    ? 'border-blue-600 bg-blue-50 shadow-md transform scale-105'
                    : 'border-gray-200 hover:border-blue-400'
                }`}
              >
                <div className="text-5xl mb-3">{topic.icon}</div>
                <h3 className="text-lg font-bold text-gray-800 mb-2">{topic.title}</h3>
                <p className="text-sm text-gray-600">{topic.description}</p>
              </button>
            ))}
          </div>

          {/* Features Highlight */}
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 mb-8">
            <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">
              ✨ Your Learning Tools
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              <div className="text-center">
                <div className="text-3xl mb-2">📚</div>
                <p className="text-sm font-medium">Interactive Courses</p>
              </div>
              <div className="text-center">
                <div className="text-3xl mb-2">🥽</div>
                <p className="text-sm font-medium">VR/AR Portal</p>
              </div>
              <div className="text-center">
                <div className="text-3xl mb-2">💬</div>
                <p className="text-sm font-medium">AI Conversations</p>
              </div>
              <div className="text-center">
                <div className="text-3xl mb-2">🎮</div>
                <p className="text-sm font-medium">Digital Twin</p>
              </div>
              <div className="text-center">
                <div className="text-3xl mb-2">🌐</div>
                <p className="text-sm font-medium">Community</p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4 justify-center">
            <button
              onClick={onClose}
              className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-all"
            >
              I'll Explore Later
            </button>
            <button
              onClick={handleGetStarted}
              className="px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl"
            >
              {selectedInterest ? `Let's Learn ${selectedInterest.title}!` : 'Get Started'}
            </button>
          </div>

          <p className="text-center text-sm text-gray-500 mt-6">
            Need help anytime? Just reach out to us - we're here for you! 💙
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
